import { useEffect, useRef } from 'react';
import { Wizard } from 'react-use-wizard';
import { trackFormStarted } from '../../shared/analytics';
import { getMatcherFormName } from './utils';
import { useMatcherContext } from './context';
import { STEP_COMPONENTS } from './flow/stepComponents';

function MatcherReferralForm() {
  const formWrapperRef = useRef<HTMLDivElement>(null);
  const hasFocused = useRef(false);
  const { stepQueue } = useMatcherContext();

  function handleOnFocusIn() {
    if (!hasFocused.current) {
      trackFormStarted({ form_name: getMatcherFormName() });
      hasFocused.current = true;
    }
  }

  useEffect(() => {
    const formWrapperRefElement = formWrapperRef.current;
    if (formWrapperRefElement) {
      formWrapperRefElement.addEventListener('focusin', handleOnFocusIn);

      return () => {
        formWrapperRefElement.removeEventListener('focusin', handleOnFocusIn);
      };
    }
  }, []);

  return (
    <div ref={formWrapperRef}>
      <Wizard>
        {stepQueue.map((stepId) => {
          const StepComponent = STEP_COMPONENTS[stepId];
          return <StepComponent key={stepId} />;
        })}
      </Wizard>
    </div>
  );
}

export { MatcherReferralForm };
